import { render } from "./FontSelectBlock.vue?vue&type=template&id=48a73e71&scoped=true&ts=true"
import script from "./FontSelectBlock.vue?vue&type=script&lang=ts"
export * from "./FontSelectBlock.vue?vue&type=script&lang=ts"

import "./FontSelectBlock.vue?vue&type=style&index=0&id=48a73e71&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a73e71"]])

export default __exports__